import { TGooglePlaceAddressSuggestion } from '../../../types/addressField.types';

const useFetchPredictions = (restrictedCountry) => {
  const getSuggestions = (
    inputValue: string,
    callback: (predictions: TGooglePlaceAddressSuggestion[]) => void
  ) => {
    if (inputValue && window.google) {
      const autocompleteService = new window.google.maps.places.AutocompleteService();

      autocompleteService.getPlacePredictions(
        {
          input: inputValue,
          types: ['address'],
          componentRestrictions: restrictedCountry,
        },
        (predictions, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
            const filteredSuggestions = predictions?.map((prediction) => ({
              description: prediction.description,
              place_id: prediction.place_id,
              structured_formatting: prediction?.structured_formatting,
            }));
            callback(filteredSuggestions || []);
          } else {
            callback([]);
          }
        }
      );
    } else {
      callback([]);
    }
  };
  return { getSuggestions };
};

export default useFetchPredictions;
